/* unplugin-vue-components disabled */import { render } from "./SArtist.vue?vue&type=template&id=19880b15&scoped=true&ts=true"
import script from "./SArtist.vue?vue&type=script&lang=ts"
export * from "./SArtist.vue?vue&type=script&lang=ts"

import "./SArtist.vue?vue&type=style&index=0&id=19880b15&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19880b15"],['__file',"src/views/searchContent/cpns/SArtist.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19880b15"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19880b15', __exports__)) {
    console.log('reload')
    api.reload('19880b15', __exports__)
  }
  
  module.hot.accept("./SArtist.vue?vue&type=template&id=19880b15&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('19880b15', render)
  })

}


export default __exports__